import { renderPlanParto } from "../plantillas/reportes/planParto";

export const REPORT_REGISTRY = {
  planParto: {
    id: "planParto",
    documentTitle: "Plan de Parto",
    legalText: "Ley 2244 de 2022 (Parto Digno y Respetado) | Resolución 3280 de 2018 (Ruta Materno-Perinatal)",
    render: renderPlanParto,
  },
};

export const getReportDefinition = (reportName) => {
  return REPORT_REGISTRY[reportName] || null;
};
